import React from 'react';
import { uniq, keyBy, } from 'lodash';
import { format as formatDate, } from 'date-fns';
import numeral from 'numeral';
import classnames from 'classnames';

import ModalButton from './ModalButton';
import useDocumentSubscription from './hooks/useDocumentSubscription';
import useDocumentsFetch from './hooks/useDocumentsFetch';

export default function ShippingRequestStatusComputationDetailButton (props) {
  const { shippingRequest } = props;
  return shippingRequest.statusComputedAt != null && (
    <ModalButton
      size="sm"
      color="info"
      label={<span className="fas fa-info" />}
      title="ステータス詳細"
      content={_ => <ModalContent shippingRequest={shippingRequest} />}
    />
  );
}

function ModalContent (props) {
  const { shippingRequest } = props;
  const tenantId = shippingRequest.ref.parent.parent.id;
  const shippingRequestAllocation = useDocumentSubscription(shippingRequest.ref.parent.parent.collection('shippingRequestAllocations').doc(shippingRequest.id), [shippingRequest?.id]);
  const products = useDocumentsFetch(uniq(shippingRequestAllocation?.allocations.map(_ => _.productId)).map(_ => shippingRequest.ref.parent.parent.collection('products').doc(_)), [shippingRequestAllocation]);
  const productsById = keyBy(products, 'id');

  return (
    <div>
      <div>
        最終計算日時: {formatDate(shippingRequest.statusComputedAt.toDate(), 'yyyy/MM/dd HH:mm:ss')}
      </div>
      <div className="mt-2 d-flex flex-column gap-2">
        {
          (shippingRequestAllocation?.allocations || shippingRequest.allocations || []).map((allocation) => {
            const { isSatisfied, productId, productInventory, allocations, isOmitted = false, } = allocation;
            return (
              <div key={productId} className={classnames('card p-2', { 'border-success': isSatisfied, 'border-danger': !isSatisfied })}>
                {isOmitted && <div className="alert alert-warning">計算量が多すぎたため一部省略しています</div>}
                <div>
                  商品ID: {[tenantId, productId].join('-')}
                </div>
                <div>
                  SKU: {productsById[productId]?.sku}
                </div>
                <div>
                  計算時の在庫数: {numeral(productInventory).format()}
                </div>
                <div className="mt-3">
                  <div className="d-flex justify-content-between text-muted small">
                    <div>
                      依頼ID
                    </div>
                    <div>
                      必要数(依頼数 - ピッキング済み数)
                    </div>
                  </div>
                  {
                    allocations.map(({ requestId, isNg, requiredQuantity, isSatisfied, }) => {
                      return (
                        <div key={requestId} className="d-flex justify-content-between">
                          <div>
                            {[tenantId, requestId].join('-')}
                            {isNg && <span className="badge badge-danger">NG</span>}
                          </div>
                          <div className={classnames({ 'text-success': isSatisfied, 'text-danger': !isSatisfied })}>
                            {numeral(requiredQuantity).format()}
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
}
